import React, { useEffect, useState } from "react";
import "../styles/BlogPageStyle/blogsStyle.css";
import CommonHeaderComp from "../utils/CommonHeaderComp";
import sotryImg1 from "../assets/StoryPage/storyImg1.png";
import sotryImg2 from "../assets/StoryPage/storyImg2.png";
import img1Toppings from "../assets/StoryPage/img1Toppings.png";
import img2Toppings from "../assets/StoryPage/Img2Toppings.png";
import Aos from "aos";
import "aos/dist/aos.css";
import banner1 from "../assets/BannerImg/banner3.png";
import banner2 from "../assets/BannerImg/banner2.png";
import ReactPaginate from "react-paginate";
import Footer from "../components/Footer";
import Loader from "../utils/Loader";
import axios from "axios";
import config from "../config";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import moment from "moment";

const BlogsPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allBlogs, setAllBlogs] = useState([]);
  const [current_location_id, setCurrentLocationId] = useState("");
  const [bannerImg1, setBannerImg1] = useState("");
  const [bannerImg2, setBannerImg2] = useState("");
    const [blog, setBlog] = useState({})

  useEffect(() => {
    const storedLocation = localStorage.getItem("location");

    if (storedLocation) {
      setCurrentLocationId(storedLocation);
    }
  }, []);

  useEffect(() => {
    if (current_location_id) {
      fetchBlogs();
    }
  }, [current_location_id]);

  const fetchBlogs = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("location", 1);
    // console.log("Fetching blogs for location:", current_location_id);
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/posts`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const resData = res.data.data.filter((item) => item.approved == 1);
        setBannerImg1(res.data?.banner_image?.image);
        setBannerImg2(res.data?.banner_image?.image2);
        // console.log("banner img 2", res.data);
        // console.log("res data", resData);
        const sortedBlogs = resData.sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });
        setAllBlogs(sortedBlogs);
        setIsLoading(false);
        // console.log("all Blogs", resData);
      });
    } catch (error) {
      console.log("fetch blogs", error);
      setIsLoading(false);
    }
  };


  const [cards, setCards] = useState([]);
  useEffect(() => {
    setCards(allBlogs);
  }, [allBlogs]);

  // pagination blogs cards
  const [currentPage, setCurrentPage] = useState(0);
  const cardsPerPage = 6;

  // Get Current Page Cards
  const offset = currentPage * cardsPerPage;
  const currentCards = cards.slice(offset, offset + cardsPerPage);
  const pageCount = Math.ceil(cards.length / cardsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({ top: 200, behavior: "smooth" });
  };

  // Handling Image
  const getImageSource = (image) => {
    if (typeof image === "string") {
      // If image is a string (URL), return it as is
      return image;
    } else if (image && image instanceof Blob) {
      // If image is an object (file), create an object URL
      return URL.createObjectURL(image);
    }
  };

  // console.log("currnt ", currentCards)

  return (
    <>
      {/* <Helmet>
        <title>Enjoy Yummy Ice Cream And Desserts Blog | Rollz Ice Cream</title>
        <meta
          name="description"
          content="Discover a treasure trove of blog content covering ice cream recipe, what is and how to make cheesecake, and much more. Feel free to explore more."
        />
        <meta
          property="og:title"
          content="Enjoy Yummy Ice Cream And Desserts Blog | Rollz Ice Cream"
        />
        <meta
          property="og:description"
          content="Discover a treasure trove of blog content covering ice cream recipe, what is and how to make cheesecake, and much more. Feel free to explore more."
        />
      </Helmet> */}
   
      {isLoading && <Loader />}
      <div className="blog_page">
        <CommonHeaderComp
          Heading="Blogs"
          height="60vh"
          startPage="Home"
          pageName="Blogs"
          color="#ffecf0"
        />

        {/* Image 1  */}

        <div className="position-absolute storyImg1" data-aos="fade-left">
          <img
            src={bannerImg1}
            className="img-fluid img1"
          // alt="our story img 1"
          ></img>
          {/* <img
            src={img1Toppings}
            className="img-fluid img1Toping"
            alt="img1 Toppings"
          ></img> */}
        </div>

        {/* Image 2  */}
        <div className="position-absolute storyImg2" data-aos="fade-rigth">
          <img
            src={bannerImg2}
            className="img-fluid img2"
          // alt="our story img 2"
          ></img>
        </div>

        {/* Blogs Container  */}
        <section className="blogpage_section">
          <div className="blogpage_container">
            <div className="column-gap-5 d-flex flex-wrap row-gap-sm-5 align-items-start justify-content-center story_blogs">
              {currentCards.map((item) =>
              {
                const evenBlog = item.id % 2 === 0;
                const colors = ["#fd85b2", "#eac76f", "#a8a3d8"];
                const bgColor = colors[item.id % colors.length];
                return (
                  <div
                    className={`single_blog mb-5 mb-md-0  d-flex justify-space-between align-items-start  ${evenBlog ? "flex-column-reverse" : "flex-column"
                      }`}
                    key={item.id}
                    style={{ backgroundColor: bgColor }}
                  >
                    <div className="blog_img">
                      <img src={item.post_img} className="img-fluid"></img>
                    </div>
                    <div className="blog_content">
                      <h6 className="blog_date mb-3">{item.publish_date ?  moment(item.publish_date).format("DD MMM YYYY") : ""}</h6>
                      <Link to={`${config.appUrl}/blog-details/${item.slug}`}>
                        <h3 className="blog_title mb-3">
                          {item.post_title.slice(0, 35) + "..."}
                        </h3>
                      </Link>
                      <div>
                        <p className="blog_para">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.post_content.slice(0, 150) + "...",
                            }}
                          ></div>
                          {item.blog_details}
                        </p>
                      </div>
                      {/* <OrderBtn text="Read More" url={`${config.apiUrl}/blogs-details`} width="fit-content" /> */}
                      <div className="order-online">
                        <Link
                          className="blue-btn hero-anchor"
                          to={`${config.appUrl}/blog-details/${item.slug}`}
                        >
                          <div className="order-online-trans-1"></div>
                          <div className="order-online-trans-2"></div>
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* pagination */}
              <div className="blogs_pagination">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={1}
                />
              </div>
            </div>
          </div>
        </section>

        {/* <Footer color="#ffecf0" /> */}
      </div>
    </>
  );
};

export default BlogsPage;
